import React, { useState, useEffect } from 'react';
import '../Home_Page/Home.css';
import { FaLeaf, FaTrophy, FaLightbulb, FaArrowRight, FaPlay, FaCheckCircle, FaUsers, FaAward, FaCog, FaStar, FaQuoteLeft, FaQuoteRight, FaInstagram, FaEnvelope, FaDownload } from 'react-icons/fa';
import { RxArrowTopRight } from 'react-icons/rx';
import { HashLink as Link } from 'react-router-hash-link';
import { useTheme } from '../../contexts/ThemeContext';
import img1 from '..//..//assets/Service-home-1.jpeg';
import img2 from '..//..//assets/3.jpeg';
import img3 from '..//..//assets/turnkey.jpg';
import jsw from '..//..//assets/jsw-steel.png';
import SK from '..//..//assets/sk.jpg';
import Kamadenu from '..//..//assets/kamadenu-new.png';
import logo from '..//..//assets/round.jpg';
import TMT from '..//..//assets/turbo-steel.jpg';
import ts from '..//..//assets/ts-new.png';
import vinay from '..//..//assets/vinay.jpg';
import abhilash from '..//..//assets/abhi.jpg';
import brochure from '..//..//assets/ABP - Product Brochure.pdf';
import ManufacturingMaterials from '..//..//Components/Manufacturing/Manufacturing';
import ConstructionMaterials from '..//..//Components/ConstructionMaterials/ConstructionMaterials';

const data = [
  {
    id: 1,
    title: 'Innovative Construction & Manufacturing',
    txt: 'Blueprinting Your Dreams , Where Imagination Meets Architecture',
    img: `${img1}`,
    tt: '',
  },
  {
    id: 2,
    title: 'Amruth Build Products',
    txt: 'Build a Better Future',
    img: `${img1}`,
    tt: 'Innovative Construction & Manufacturing',
  },
  {
    id: 3,
    title: 'Services',
    txt: 'Planning & Designing',
    img: `${img2}`,
    tt: 'Blueprinting Your Dreams,Where Imagination Meets Architecture',
  },
  {
    id: 4,
    title: 'Services',
    txt: 'Estimation and Costing',
    img: `${logo}`,
    tt: 'Building with Precision, Budget in Mind',
  },
  {
    id: 5,
    title: 'Services',
    txt: 'Turn Key Projects',
    img: `${img3}`,
    tt: ' Seamless Execution, Stress-Free Experience',
  },
];

function Home() {
  const [index] = useState(0);
  const { theme } = useTheme();
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);
  
  const stats = [
    { number: '30+', label: 'Projects Completed', icon: FaCheckCircle },
    { number: '20+', label: 'Happy Clients', icon: FaUsers },
    { number: '2+', label: 'Years Experience', icon: FaAward },
    { number: '24/7', label: 'Support', icon: FaCog }
  ];
  
  return (
    <div className='modern-home-container'>
      {/* Hero Section */}
      <section className='hero-section mt-4'>
        <div className='hero-background'></div>
        <div className='hero-overlay'></div>
        <div className='container hero-content '>
          <div className='row align-items-center '>
            <div className='col-lg-6 col-12'>
              <div className={`hero-text ${isVisible ? 'animate-in' : ''}`}>
                <div className='hero-badge'>
                  <span className='badge-text'>🏗️ Building Excellence Since 2022</span>
                </div>
                <h1 className='hero-title home-hero-title' >
                  <span className='text-gradient'>Innovative Construction</span>
                  <br />
                  <span className='text-primary'>& Manufacturing Solutions</span>
                </h1>
                <p className='hero-description-home'>
                  Transform your vision into reality with our cutting-edge construction 
                  and manufacturing services. We deliver exceptional quality, 
                  sustainable practices, and innovative solutions.
                </p>
                <div className='hero-buttons'>
                  <div className='d-flex flex-wrap gap-3'>
                    <Link to='/about' className='btn-modern btn-primary btn-sm d-inline-flex align-items-center'>
                      <FaArrowRight className='me-2' />
                      Explore Our Work
                    </Link>
                    <a
                      href={brochure}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='btn-modern btn-primary btn-sm d-inline-flex align-items-center'
                      download='Amruth-Build-Product-Brochure.pdf'
                    >
                      <FaDownload className='me-2' />
                      Download Brochure
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-6 col-12'>
              <div className={`hero-visual ${isVisible ? 'animate-in-right' : ''}`}>
                <div className='floating-card card-1'>
                  <div className='card-content'>
                    <FaLightbulb className='card-icon' />
                    <h4>Innovation</h4>
                    <p>Cutting-edge solutions</p>
                  </div>
                </div>
                <div className='floating-card card-2' style={{marginRight: '20px',marginTop:'-100px'}}>
                  <div className='card-content'>
                    <FaLeaf className='card-icon' />
                    <h4>Sustainability</h4>
                    <p>Eco-friendly practices</p>
                  </div>
                </div>
                <div className='floating-card card-3'>
                  <div className='card-content'>
                    <FaTrophy className='card-icon' />
                    <h4>Excellence</h4>
                    <p>Quality guaranteed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Stats Section */}
      <section className='stats-section'>
        <div className='container'>
          <div className='row'>
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div key={index} className='col-lg-3 col-md-6 col-12 mb-4'>
                  <div className='stat-card' data-aos='fade-up' data-aos-delay={index * 100}>
                    <div className='stat-icon'>
                      <IconComponent />
                    </div>
                    <div className='stat-content'>
                      <h3 className='stat-number'>{stat.number}</h3>
                      <p className='stat-label'>{stat.label}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* Features Section */}
      <section className='features-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <span className='text-gradient'>Building Your Vision,</span>
              <br />Brick By Brick
            </h2>
            <p className='section-description'>
              We combine innovation, sustainability, and excellence to deliver 
              construction solutions that exceed expectations.
            </p>
          </div>
          <div className='row g-4'>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='feature-card' data-aos='fade-up' data-aos-duration='600'>
                <div className='feature-icon-home'>
                  <FaLightbulb />
                </div>
                <div className='feature-content'>
                  <h3 className='feature-title'>Innovation</h3>
                  <p className='feature-description'>
                    Blending technology and creativity, we exceed client expectations.
                    Fresh ideas drive continuous enhancement of our offerings.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='feature-card' data-aos='fade-up' data-aos-duration='600' data-aos-delay='200'>
                <div className='feature-icon-home'>
                  <FaLeaf />
                </div>
                <div className='feature-content'>
                  <h3 className='feature-title'>Sustainability</h3>
                  <p className='feature-description'>
                    Our work is rooted in sustainability. We envision an eco-friendly
                    future with responsible construction and efficient manufacturing.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 col-12'>
              <div className='feature-card' data-aos='fade-up' data-aos-duration='600' data-aos-delay='400'>
                <div className='feature-icon-home'>
                  <FaTrophy />
                </div>
                <div className='feature-content'>
                  <h3 className='feature-title'>Excellence</h3>
                  <p className='feature-description'>
                    Quality defines our every action, from intricate details to grand
                    undertakings. Our dedication sets us apart.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      <div className='container-fluid trusted-text-container p-0'>
        <div
          className='pt-5 px-sm-0 px-3'
          data-aos='fade-up'
          data-aos-duration='1100'
        >
          <h3 className='main-text text-center'>
            Trusted by well known companies
          </h3>
          <p className='sub-text mt-5 text-center'>
            We take pride in our commitment to delivering exceptional services
            that meet the high standards of industry leaders.
          </p>
        </div>
        <div className='row px-0 d-flex justify-content-center align-items-center '>
          <div className=''>
            <div className='logos'>
              <div className='logos-slide'>
                <img loading='lazy' src={jsw} alt='' />
                <img loading='lazy' src={SK} alt='' />
                <img loading='lazy' src={ts} alt='' />
                <img
                  loading='lazy'
                  className='Kamadenu'
                  src={Kamadenu}
                  alt=''
                />
                <img loading='lazy' src={jsw} alt='' />
                <img loading='lazy' src={SK} alt='' />
                <img loading='lazy' src={TMT} alt='' />
                <img
                  loading='lazy'
                  className='Kamadenu'
                  src={Kamadenu}
                  alt=''
                />
              </div>
              <div className='logos-slide'>
                <img loading='lazy' src={jsw} alt='' />
                <img loading='lazy' src={SK} alt='' />
                <img loading='lazy' src={ts} alt='' />
                <img
                  loading='lazy'
                  className='Kamadenu'
                  src={Kamadenu}
                  alt=''
                />
                <img loading='lazy' src={jsw} alt='' />
                <img loading='lazy' src={SK} alt='' />
                <img loading='lazy' src={TMT} alt='' />
                <img
                  loading='lazy'
                  className='Kamadenu'
                  src={Kamadenu}
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className='services-section'>
        <div className='container'>
          <div className='section-header text-center mb-5'>
            <h2 className='section-title'>
              <span className='text-gradient'>Bringing Your Visions</span>
              <br />to Life
            </h2>
            <p className='section-description'>
              From concept to completion, we provide comprehensive construction 
              and manufacturing solutions tailored to your needs.
            </p>
          </div>
          
          <div className='services-grid'>
            <div className='service-card' data-aos='fade-up' data-aos-duration='600'>
              <div className='service-image'>
                <img src={img1} alt='Planning and Designing' className='img-fluid' />
              </div>
              <div className='service-content-home'>
                <h3 className='service-title'>Planning & Designing</h3>
                <p className='service-description'>
                  Our experts turn your construction vision into reality, blending
                  functionality with aesthetics for beautifully crafted spaces.
                </p>
                <Link to='/services' className='service-link'>
                  Learn More <FaArrowRight className='ms-2' />
                </Link>
              </div>
            </div>
            
            <div className='service-card' data-aos='fade-up' data-aos-duration='600' data-aos-delay='200'>
              <div className='service-image'>
                <img src={img2} alt='Estimation and Costing' className='img-fluid' />
              </div>
              <div className='service-content-home'>
                <h3 className='service-title'>Estimation & Costing</h3>
                <p className='service-description'>
                  Transparent and accurate cost analysis with detailed breakdowns,
                  helping you manage your project budget effectively.
                </p>
                <Link to='/services' className='service-link'>
                  Learn More <FaArrowRight className='ms-2' />
                </Link>
              </div>
            </div>
            
            <div className='service-card' data-aos='fade-up' data-aos-duration='600' data-aos-delay='400'>
              <div className='service-image'>
                <img src={img3} alt='Turnkey Projects' className='img-fluid' />
              </div>
              <div className='service-content-home'>
                <h3 className='service-title'>Turnkey Projects</h3>
                <p className='service-description'>
                  Complete end-to-end solutions from concept to execution,
                  ensuring a seamless experience and exceptional results.
                </p>
                <Link to='/services' className='service-link'>
                  Learn More <FaArrowRight className='ms-2' />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className='my-4 p-0 px-2 container'
        data-aos='fade-up'
        data-aos-duration='1200'
      >
        <ManufacturingMaterials />
      </div>
      
      <div
        className='my-4 p-0 px-2 container'
        data-aos='fade-up'
        data-aos-duration='1200'
      >
        <ConstructionMaterials />
      </div>

      {/* Owner/Manager Section */}
      <section className='owner-section'>
        <div className='container'>
          <div className='row justify-content-center g-4'>
            {/*Card */}
            <div className='col-lg-5 col-md-6 col-12'>
              <div className='owner-card-new h-100'>
                <div className='card-background'>
                  <div className='card-gradient' style={{background: 'linear-gradient(135deg, #4b6cb7, #182848)'}}></div>
                </div>
                <div className='card-content'>
                  <div className='card-top'>
                    <div className='owner-avatar'>
                      <img 
                        src={abhilash}
                        alt='Manager Name' 
                        className='avatar-img'
                      />
                      <div className='avatar-pulse'></div>
                    </div>
                    <div className='owner-details'>
                      <h2 className='owner-name'>ABHILASH N B</h2>
                      <div className='owner-role'>
                        <span className='role-badge'>Managing partner</span>
                      </div>
                      <div className='social-links-home'>
                        <a href='https://www.instagram.com/abhilash_n_bharadwaj/' target='_blank' rel='noopener noreferrer' className='social-link-home'>
                          <div className='social-icon-wrapper'>
                            <FaInstagram />
                          </div>
                        </a>
                        <a href='mailto:amruthbuildproducts@gmail.com' target='_blank' rel='noopener noreferrer' className='social-link-home'>
                          <div className='social-icon-wrapper'>
                            <FaEnvelope />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  
                  <div className='card-divider' style={{background: 'linear-gradient(90deg, rgba(75,108,183,0.1), rgba(75,108,183,0.6), rgba(75,108,183,0.1))'}}></div>
                  
                  <div className='card-quote'>
                    <div className='quote-icon'>
                      <FaQuoteLeft />
                    </div>
                    <p className='quote-text'>
                      Delivering excellence through dedication, teamwork, and customer satisfaction.
                    </p>
                    <div className='quote-icon quote-icon-right'>
                      <FaQuoteRight />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-5 col-md-6 col-12'>
              <div className='owner-card-new h-100'>
                <div className='card-background'>
                  <div className='card-gradient'></div>
                </div>
                <div className='card-content'>
                  <div className='card-top'>
                    <div className='owner-avatar'>
                      <img 
                        src={vinay} 
                        alt='Vinay Yadravi' 
                        className='avatar-img'
                      />
                      <div className='avatar-pulse'></div>
                    </div>
                    <div className='owner-details'>
                      <h2 className='owner-name'>Vinay Yadravi</h2>
                      <div className='owner-role'>
                        <span className='role-badge'>Managing partner</span>
                      </div>
                      <div className='social-links-home'>
                        <a href='https://www.instagram.com/vinaygowdaofficial/' target='_blank' rel='noopener noreferrer' className='social-link-home'>
                          <div className='social-icon-wrapper'>
                            <FaInstagram />
                          </div>
                        </a>
                        <a href='mailto:amruthbuildproducts@gmail.com' target='_blank' rel='noopener noreferrer' className='social-link-home'>
                          <div className='social-icon-wrapper'>
                            <FaEnvelope />
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  
                  <div className='card-divider'></div>
                  
                  <div className='card-quote'>
                    <div className='quote-icon'>
                      <FaQuoteLeft />
                    </div>
                    <p className='quote-text'>
                      Building dreams into reality with innovation, integrity, and excellence.
                    </p>
                    <div className='quote-icon quote-icon-right'>
                      <FaQuoteRight />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  );
}

export default Home;
